import { SmartInput } from '@web/ui';

import type { TaskStatus } from '@/features/tasks/types';

type TaskStatusSelectProps = {
  value: TaskStatus;
  onChange: (value: TaskStatus) => void;
  error?: string;
  disabled?: boolean;
  label?: string;
  name?: string;
  size?: 'small' | 'medium';
};

const TASK_STATUS_OPTIONS = [
  { value: 'backlog', label: 'Backlog' },
  { value: 'inprogress', label: 'In Progress' },
  { value: 'completed', label: 'Completed' },
] as const;

export function TaskStatusSelect({
  value,
  onChange,
  error,
  disabled = false,
  label = 'Status',
  name = 'task-status',
  size = 'medium',
}: TaskStatusSelectProps) {
  return (
    <SmartInput
      type="select"
      name={name}
      label={label}
      size={size}
      value={value}
      options={TASK_STATUS_OPTIONS.map((option) => ({
        value: option.value,
        label: option.label,
      }))}
      error={error}
      readOnly={disabled}
      onChange={(nextValue) => onChange(String(nextValue) as TaskStatus)}
    />
  );
}
